import React from "react";
import { Link, useLocation } from "react-router-dom";

/**
 * Slim, quiet global footer. Hidden inside the map/landing page where
 * screen space is already contested, and on the two legal pages themselves
 * (they have their own back links). Shows on dashboards, forms, and status.
 */
const HIDE_ON = ["/", "/terms", "/privacy"];

export default function Footer() {
  const { pathname } = useLocation();
  if (HIDE_ON.some((p) => pathname === p)) return null;

  return (
    <footer
      data-testid="app-footer"
      className="print:hidden mt-16 border-t border-border py-6 px-4 md:px-8"
    >
      <div className="mx-auto max-w-[1400px] flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between text-[11px] text-muted-foreground">
        <p className="mono uppercase tracking-widest">
          © {new Date().getFullYear()} Book Away
        </p>
        <nav className="flex items-center gap-5">
          <Link
            to="/pricing"
            data-testid="footer-pricing-link"
            className="mono uppercase tracking-widest hover:text-foreground transition-colors"
          >
            Pricing
          </Link>
          <Link
            to="/terms"
            data-testid="footer-terms-link"
            className="mono uppercase tracking-widest hover:text-foreground transition-colors"
          >
            Terms
          </Link>
          <Link
            to="/privacy"
            data-testid="footer-privacy-link"
            className="mono uppercase tracking-widest hover:text-foreground transition-colors"
          >
            Privacy
          </Link>
          <a
            href="mailto:hello@bookaway.com.au"
            data-testid="footer-contact-link"
            className="mono uppercase tracking-widest hover:text-foreground transition-colors"
          >
            Contact
          </a>
        </nav>
      </div>
    </footer>
  );
}
